import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b168e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__skeleton-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "header__warning"
}
const _hoisted_4 = { class: "header__button-group" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Отчёты ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Показатели ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Статистика ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Динамика ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Организации ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Пользователи ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Отчёты ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Архив ")
const _hoisted_13 = { class: "header__clinic" }
const _hoisted_14 = { class: "header__button-group" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Новый отчет ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Добавить пациента ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Добавить организацию ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Добавить врача ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Настройки ")

import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { FLogout } from '@/features/FLogout'
import { useUser } from '@/shared/composables'
import { getDateDistance } from '@/shared/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const landingLink = ref<string>()

const router = useRouter()
const route = useRoute()

const { isAuth } = useUser()

const { user } = useUser()

const isSubscriptionEnded = computed(
  () =>
    !getDateDistance(user.value.organization.block_at) ||
    !user.value.organization.package_count
)

const isAuthPage = computed(() => isAuth.value)

const currentMode = ref('reports')
const isAdmin = computed((): boolean => user.value.role === 'admin')
const isHeadDoctor = computed((): boolean => user.value.role === 'head_doctor')

const handleToggleMode = (mode: string): void => {
  switch (mode) {
    case 'statistic':
      router.push({ name: 'StatisticPage' })
      break
    case 'reports':
      router.push({ name: 'PatientListingPage' })
      break
    case 'dynamics':
      if (isAdmin.value) {
        router.push({
          name: 'StatisticTablePage',
        })
      } else if (isHeadDoctor.value) {
        router.push({
          name: 'StatisticTablePage',
          query: { organizationId: user.value.organization.id },
        })
      }
      break
    case 'plaque-dynamics':
      router.push({ name: 'PlaqueDynamicsPage' })
      break
    case 'users':
      router.push({ name: 'UserListingPage' })
      break
    case 'organizations':
      router.push({
        name: 'AllOrganizationsPage',
      })
      break
    case 'reports-list':
      router.push({ name: 'ReportsPage', query: { page: 1 } })
      break
    case 'org-archive':
      router.push({
        name: 'AllOrganizationsPage',
        query: { mode: 'archive' },
      })
  }

  currentMode.value = mode
}

const handleOpenReportCreationPage = (): void => {
  router.push({
    name: 'ReportCreationPage',
    params: { patientId: 'null-patient' },
  })
  currentMode.value = null
}

const handleOpenPatientCreationPage = (): void => {
  router.push({ name: 'PatientCreationPage' })
  currentMode.value = null
}

const handleOpenDoctorCreationPage = (): void => {
  router.push({ name: 'UserCreationPage' })
  currentMode.value = null
}

const handleCreateOrganization = (): void => {
  router.push('/admin/organizations/create')
  currentMode.value = null
}

const handleOpenSettings = (): void => {
  router.push({ name: 'SettingsPage' })
  currentMode.value = null
}

onMounted(() => {
  landingLink.value = window.origin

  switch (route.name) {
    case 'StatisticPage':
      currentMode.value = 'statistic'
      break
    case 'PatientListingPage':
      currentMode.value = 'reports'
      break
    case 'StatisticTablePage':
      currentMode.value = 'dynamics'
      break
    case 'PlaqueDynamicsPage':
      currentMode.value = 'plaque-dynamics'
      break
    case 'UserPage':
      currentMode.value = 'users'
      break
    case 'ReportsPage':
      currentMode.value = 'reports-list'
      break
    case 'AllOrganizationsPage':
      if (route.query.mode && route.query.mode == 'archive') {
        currentMode.value = 'org-archive'
      } else {
        currentMode.value = 'organizations'
      }
      break
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_skeleton, {
      loading: !_unref(isAuthPage),
      class: "header__skeleton"
    }, {
      template: _withCtx(() => [
        _createVNode(_component_el_skeleton_item, {
          class: "header__skeleton-group",
          variant: "text"
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_skeleton_item, {
            class: "header__skeleton-report",
            variant: "text"
          }),
          _createVNode(_component_el_skeleton_item, {
            class: "header__skeleton-add-patient",
            variant: "text"
          })
        ])
      ]),
      default: _withCtx(() => [
        (_unref(isSubscriptionEnded))
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Внимание! У вас закончилась подписка "))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(isAdmin) ? 'header__wrapper_admin' : 'header__wrapper')
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button_group, { class: "header__button" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: currentMode.value === 'reports' ? 'primary' : '',
                  round: "",
                  size: "small",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleToggleMode('reports')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createVNode(_component_el_button, {
                  type: currentMode.value === 'statistic' ? 'primary' : '',
                  round: "",
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToggleMode('statistic')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["type"]),
                (_unref(isAdmin) || _unref(isHeadDoctor))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleToggleMode('dynamics'))),
                      size: "small",
                      type: currentMode.value === 'dynamics' ? 'primary' : '',
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["type"]))
                  : _createCommentVNode("", true),
                (_unref(isAdmin))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (handleToggleMode('plaque-dynamics'))),
                      size: "small",
                      type: currentMode.value === 'plaque-dynamics' ? 'primary' : '',
                      round: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["type"]))
                  : _createCommentVNode("", true),
                (_unref(isAdmin))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: currentMode.value === 'organizations' ? 'primary' : '',
                      round: "",
                      size: "small",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (handleToggleMode('organizations')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["type"]))
                  : _createCommentVNode("", true),
                (_unref(isAdmin))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      type: currentMode.value === 'users' ? 'primary' : '',
                      round: "",
                      size: "small",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handleToggleMode('users')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["type"]))
                  : _createCommentVNode("", true),
                (_unref(isAdmin))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 4,
                      class: "header__button",
                      round: "",
                      type: currentMode.value === 'reports-list' ? 'primary' : '',
                      size: "small",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (handleToggleMode('reports-list')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["type"]))
                  : _createCommentVNode("", true),
                (_unref(isAdmin))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 5,
                      type: currentMode.value === 'org-archive' ? 'primary' : '',
                      round: "",
                      size: "small",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (handleToggleMode('org-archive')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["type"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(user).organization.name), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (!_unref(isSubscriptionEnded))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "header__button",
                  type: "primary",
                  round: "",
                  size: "small",
                  onClick: handleOpenReportCreationPage
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              class: "header__button",
              type: "default",
              round: "",
              size: "small",
              onClick: handleOpenPatientCreationPage
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            (_unref(isAdmin))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_button, {
                    class: "header__button",
                    type: "primary",
                    round: "",
                    size: "small",
                    onClick: handleCreateOrganization
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    class: "header__button",
                    type: "default",
                    round: "",
                    size: "small",
                    onClick: handleOpenDoctorCreationPage
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              class: "header__button",
              round: "",
              size: "small",
              onClick: handleOpenSettings
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_unref(FLogout))
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

})